





































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { teamManage } from './team';
import { timeFormat } from '@/utils/other';
import TeamModal from './components/teamModal.vue';

type ITeamInfo = ITeam.IResponse.ITeamInfo;

const columns = [
  {
    slots: { title: 'nameTit' },
    dataIndex: 'name',
    // scopedSlots: { customRender: 'name'},
    width: '10%',
  },
  {
    slots: { title: 'ownerTit' },
    dataIndex: 'leaderName',
    scopedSlots: { customRender: 'leader'},
    width: '8%',
  },
  {
    slots: { title: 'createdNameTit' },
    dataIndex: 'createdName',
    scopedSlots: { customRender: 'createdName'},
    width: '17%',
    align: 'center',
  },
  {
    slots: { title: 'managerTit' },
    dataIndex: 'manager',
    scopedSlots: { customRender: 'manager'},
    width: '15%',
  },
  {
    slots: { title: 'memberTit' },
    dataIndex: 'members',
    scopedSlots: { customRender: 'members'},
    width: '35%',
  },
  {
    slots: { title: 'activeTit' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'active'},
    width: '5%',
    align: 'center',
  },
  {
    slots: { title: 'actionTit' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '10%',
    align: 'center',
  },
];

@Component({
  name: 'Team',
  filters: {
    timeFormat,
  },
  components: {
    TeamModal,
  },
})
export default class Team extends Vue {
  @Ref() private readonly teamModal!: TeamModal;
  private teamManage = teamManage;
  private columns = columns;
  private currentPage = 1;
  private addLoading = false;
  private pagination = {
    pageSize: 10,
    hideOnSinglePage: true,
  };
  private spinning = false;
  get totalPageCount() {
    return Math.ceil(this.teamList.length / this.pagination.pageSize);
  }
  get isLastPage() {
    return this.currentPage >= this.totalPageCount;
  }
  get teamList() {
    return this.teamManage.tableData;
  }
  get isMore() {
    return this.teamManage.isMore;
  }
  private created() {
    this.refreshTeams();
  }
  private destroyed() {
    teamManage.clearData();
  }
  private refreshTeams() {
    this.spinning = true;
    teamManage.requestGetTeams().then((res) => {
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private getMoreTeams() {
    this.addLoading = true;
    teamManage.requestGetMoreTeams().then((res) => {
      this.addLoading = false;
    }).catch((err) => {
      this.addLoading = false;
      this.$message.warning(err);
    });
  }
  private createTeam() {
    teamManage.createTeam();
    this.teamModal.showModal();
  }
  private editTeam(team: ITeamInfo) {
    teamManage.editTeam(team);
    this.teamModal.showModal();
  }
  private editMembers(team: ITeamInfo, type: 'add' | 'del') {
    teamManage.editTeam(team);
    this.teamModal.showModal('edit-members', type);
  }
  private editManagers(team: ITeamInfo, type: 'add' | 'del') {
    teamManage.editTeam(team);
    this.teamModal.showModal('edit-managers', type);
  }
  private deleteTeam(teamId: string) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        this.submitDelete(teamId);
      },
    });
  }
  private submitDelete(teamId: string) {
   teamManage.requestDeleteTeam(teamId).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleTableChange(pagination: any) {
    this.currentPage = pagination.current;
  }
}
